import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { checkDayClose } from "./thunks/check-close";
import { submitDayClose } from "./thunks/submit-close";

const name = "dayClose";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitDayClose.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = "";
      })
      .addCase(submitDayClose.fulfilled, (state) => {
        state.isSubmitting = false;
        state.closed = true;
      })
      .addCase(submitDayClose.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError = action.error.message ?? "";
      })
      .addCase(checkDayClose.fulfilled, (state, action) => {
        state.closed = action.payload;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
